import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './stylesheets/main.css';

import NextCatchup from './Modules/NextCatchup';
import YourProgress from './Modules/YourProgress';
import YourStory from './Modules/YourStory';
import RelatedArticles from './Modules/RelatedArticles';
import RelatedActivities from './Modules/RelatedActivities';

import { pingLogin } from '../../Actions/Dashboard/login';
import api from '../../lib/api';

class Dashboard extends React.Component {
  componentDidMount() {
    if (this.props.login) {
      api.setToken(this.props.login);
      this.props.dispatch(pingLogin(this.props.login.access_token, this.props.login.refresh_token));

    //   const elButton = document.getElementsByClassName('js-comb-login')[0];
    //   elButton.innerText = 'Logout';
    //   elButton.onclick = function doLogout(e) {
    //     localStorage.clear();
    //     window.location = '/login';
    //     e.preventDefault();
    //   };
    }
  }

  render() {
    return (
      <div className={`wrap dashboard ${this.props.pathway}`}>
        <h2 className="title">Your Progress</h2>
        <NextCatchup />
        <YourProgress />
        <YourStory />
        <h2 className="title">Activities near you</h2>
        <RelatedActivities />
        <h2 className="title">Articles to support your journey</h2>
        <RelatedArticles />
      </div>
    );
  }
}

Dashboard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  login: PropTypes.object,
};

Dashboard.defaultProps = {
  login: {},
};

export default connect(state => ({
  login: state.login,
  pathway: state.pathway,
}), dispatch => ({ dispatch }))(Dashboard);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/index.jsx